export const IMG_CDN =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const IMG_NOTFOOD =
  "https://www.food4fuel.com/wp-content/uploads/woocommerce-placeholder-600x600.png";
// export const URL_MENU =
//   "https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=18.5204303&lng=73.8567437&restaurantId=";

export const URL_MENU =
  "https://food-delivery-cors.vercel.app/api/proxy/swiggy/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&";

export const LOCATION_API =
  "https://food-delivery-cors.vercel.app/api/proxy/swiggy/dapi/misc/place-autocomplete?input=";

export const ADDRESS_RECOMENDATION =
  "https://food-delivery-cors.vercel.app/api/proxy/swiggy/dapi/misc/address-recommend?place_id=";

export const RESTAURANT_LIST =
  "https://food-delivery-cors.vercel.app/api/proxy/swiggy/dapi/restaurants/list/v5?";
